var exports = {
  "Qs": "CameraPreviewModal.module__content___TmkzQW",
  "Wc": "CameraPreviewModal.module__backgroundSection___TmkzQW",
  "Pz": "CameraPreviewModal.module__backgroundLabel___TmkzQW",
  "Ip": "CameraPreviewModal.module__effectStrengthSlider___TmkzQW",
  "TM": "CameraPreviewModal.module__effectStrengthLabelRow___TmkzQW",
  "dI": "CameraPreviewModal.module__effectStrengthLabel___TmkzQW",
  "j": "CameraPreviewModal.module__videoContainer___TmkzQW",
  "qr": "CameraPreviewModal.module__footer___TmkzQW",
  "wu": "CameraPreviewModal.module__footerStart___TmkzQW",
  "Dr": "CameraPreviewModal.module__footerMirrorSwitch___TmkzQW",
  "Ki": "CameraPreviewModal.module__video___TmkzQW",
  "Lw": "CameraPreviewModal.module__overlay___TmkzQW",
  "um": "CameraPreviewModal.module__overlayText___TmkzQW",
  "nU": "CameraPreviewModal.module__overlayTextMedium___TmkzQW",
  "$q": "CameraPreviewModal.module__errorOverlay___TmkzQW",
  "kc": "CameraPreviewModal.module__errorText___TmkzQW",
  "JU": "CameraPreviewModal.module__errorTitle___TmkzQW",
  "m2": "CameraPreviewModal.module__errorDetail___TmkzQW",
};

module.exports = exports;
